var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{ref:"selection",attrs:{"border":"","columns":_vm.mColumns,"data":_vm.columns},on:{"on-select":_vm.handleSelect,"on-select-cancel":_vm.handleSelectCancel,"on-select-all":_vm.handleSelectAll,"on-select-all-cancel":_vm.handleSelectAllCancel}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-297e7454","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pdMonitor/pdMonitorIndex/dynamicColumnSelect.vue
// module id = null
// module chunks = 